import React from 'react';

/**
 * ÐÐ¾Ð¼ÐµÑÐºÐ° Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Ñ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ ÑÑÐ»ÑÐ³Ð¾Ð¹.
 *
 * Ð¤Ð¾ÑÑÐµ Ñ 15.10.2026 Ð¾ÑÐ´Ð°ÑÑ Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐµ Ð´Ð²Ð° ÑÐµÑÐµÐ½Ð¸Ñ: Ð¾Ð±ÑÑÐ½Ð¾Ðµ Ð¸ Ñ ÑÑÐ»ÑÐ³Ð¾Ð¹
 * Â«ÐÐ¾Ð¼Ð¾ÑÑ Ð½Ð° Ð´Ð¾ÑÐ¾Ð³ÐµÂ», ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ ÑÐ¶Ðµ Ð²ÐºÐ»ÑÑÐµÐ½Ð° Ð² ÑÑÐ¼Ð¼Ñ Ð·Ð°Ð¹Ð¼Ð°. ÐÐ½ÐµÑÐ½Ðµ
 * ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð¾ÑÐ»Ð¸ÑÐ°ÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¼Ð¼Ð¾Ð¹ Ð¸ Ð¿Ð»Ð°ÑÐµÐ¶Ð¾Ð¼, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð±ÐµÐ· Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ
 * Ð½Ðµ Ð¿Ð¾Ð¹Ð¼ÑÑ, Ð·Ð° ÑÑÐ¾ ÐºÐ»Ð¸ÐµÐ½Ñ Ð´Ð¾Ð¿Ð»Ð°ÑÐ¸Ð²Ð°ÐµÑ, Ð¸ Ð²ÑÐ±ÐµÑÐµÑ Ð½Ð°ÑÐ³Ð°Ð´.
 */
export const hasRoadAssistance = (condition) => condition?.road_assistance === true;

export const roadAssistanceTitle = (condition) =>
  (condition?.road_assistance_name || '').trim() || 'ÐÐ¾Ð¼Ð¾ÑÑ Ð½Ð° Ð´Ð¾ÑÐ¾Ð³Ðµ';

const RoadAssistanceBadge = ({ condition }) => {
  if (!hasRoadAssistance(condition)) return null;

  return (
    <div
      style={{
        background: '#EAF6EC',
        border: '1px solid #9BCBA4',
        borderRadius: 6,
        padding: '8px 12px',
        marginBottom: 12,
        fontSize: 14,
      }}
    >
      <b>Ð¡ ÑÑÐ»ÑÐ³Ð¾Ð¹ Â«{roadAssistanceTitle(condition)}Â»</b> â ÐµÑ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÑÐ¶Ðµ Ð²ÐºÐ»ÑÑÐµÐ½Ð° Ð² ÑÑÐ¼Ð¼Ñ Ð·Ð°Ð¹Ð¼Ð°
      Ð¸ ÐµÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÑÐ¶.
    </div>
  );
};

export default RoadAssistanceBadge;
